export const USER_INFO_RECEIVED = "user_info_received";
export const USER_EDIT_FAILED = "user_edit_failed";
export const USER_UPDATED = "user_updated";
export const USER_LOGGED_IN = "user_logged_in";
export const USER_LOGGED_OUT = "user_logged_out";
export const LOGIN_FAILED = "login_failed";
export const REGISTER_FAILED = "register_failed";
export const PASSWORD_CHANGED = "password_changed";
export const PASSWORD_CHANGE_FAILED = "password_change_failed";
export const PASSWORD_RECOVERY_SENT = "password_recovery_sent";
export const PASSWORD_RECOVERY_FAILED = "password_recovery_failed";
export const PASSWORD_RESET = "password_reset";
export const PASSWORD_RESET_FAILED = "password_reset_failed";
export const ADDRESS_FAILED = "address_failed";
export const IS_AUTHENTICATED = "is_authenticated";
export const GUEST_ALERT_STATUS_UPDATED = "guest_Alert_Status_updated";
export const BILLING_ADDRESS_ADDED = "billing_Address_added";
export const ORDERS_RECEIVED = "orders_received";
export const ORDER_DETAIL_RECEIVED = "order_detail_received";
export const COMPANIES_RECEIVED = "companies_received";